import { Product } from '../../types/product';

/**
 * 一覧など他ページから `?product=<id>` で来たときに選択する商品のサービス id。
 * サービス id の形は KnowledgeDashboard の `product_${product.id}` に合わせる。
 *
 * パラメータが無い / 商品 id でない / その商品が組織に無い（読み込み前も含む）なら null を返し、
 * 呼び出し側は既存の初期選択（先頭の商品）にそのまま任せる。
 */
export const selectedServiceFromProductParam = (
  productParam: string | null,
  products: Product[] | null | undefined,
): string | null => {
  if (!productParam) {
    return null;
  }
  const target = (products ?? []).find((product) => String(product.id) === productParam);

  return target ? `product_${target.id}` : null;
};
